export const getQueryParameter = (paramName: string) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(paramName);
};

export const updateURLQuery = (query: string) => {
  const url = new URL(window.location.href);
  if (query) {
    url.searchParams.set('query', query);
  } else {
    url.searchParams.delete('query');
  }
  window.history.pushState({}, '', url);
};
